import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  ApiResponse, UserProfileResponse, CreateUserRequest, UpdateUserRequest,
  AssignRolesRequest
} from '../models/models';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private readonly apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getCurrentUser(): Observable<ApiResponse<UserProfileResponse>> {
    return this.http.get<ApiResponse<UserProfileResponse>>(`${this.apiUrl}/user`);
  }

  getAllUsers(): Observable<ApiResponse<UserProfileResponse[]>> {
    return this.http.get<ApiResponse<UserProfileResponse[]>>(`${this.apiUrl}/users`);
  }

  getUserByUid(uid: string): Observable<ApiResponse<UserProfileResponse>> {
    return this.http.get<ApiResponse<UserProfileResponse>>(`${this.apiUrl}/users/${uid}`);
  }

  createUser(request: CreateUserRequest): Observable<ApiResponse<UserProfileResponse>> {
    return this.http.post<ApiResponse<UserProfileResponse>>(`${this.apiUrl}/users/create`, request);
  }

  updateUser(uid: string, request: UpdateUserRequest): Observable<ApiResponse<UserProfileResponse>> {
    return this.http.put<ApiResponse<UserProfileResponse>>(`${this.apiUrl}/users/${uid}`, request);
  }

  deleteUser(uid: string): Observable<ApiResponse<void>> {
    return this.http.delete<ApiResponse<void>>(`${this.apiUrl}/users/${uid}`);
  }

  assignRoles(uid: string, request: AssignRolesRequest): Observable<ApiResponse<UserProfileResponse>> {
    return this.http.post<ApiResponse<UserProfileResponse>>(`${this.apiUrl}/users/assign-roles/${uid}`, request);
  }

  changeCurrentUserPassword(request: import('../models/models').ResetPasswordRequest): Observable<ApiResponse<string>> {
    return this.http.post<ApiResponse<string>>(`${this.apiUrl}/user/change-password`, request);
  }

  updateCurrentUserMfa(enabled: boolean): Observable<ApiResponse<UserProfileResponse>> {
    return this.http.put<ApiResponse<UserProfileResponse>>(`${this.apiUrl}/user/mfa`, { enabled });
  }

  updateUserMfa(uid: string, enabled: boolean): Observable<ApiResponse<UserProfileResponse>> {
    return this.http.put<ApiResponse<UserProfileResponse>>(`${this.apiUrl}/users/${uid}/mfa`, { enabled });
  }
}
